var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},_vm._l((this.icon),function(menuOption,iconKey){return _c('span',{key:iconKey,class:_vm.getSelectedClass(iconKey),on:{"click":function($event){_vm.changeMenu('iconKey')}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":menuOption}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eaccf02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/brand/xugarhero/components/XugarMenu.vue
// module id = null
// module chunks = 